import axios from "axios";

import authHeader from "./authHeader";
import { NotificationConfigUpdate } from "../store/types";
import { SelfRegisterArgs } from "../store/login-reducer/types";
import { WorkflowAdvanceArgs } from "../store/admin-reducer/account-reducer/types";
import { baseUrl, host, adminApi, tenant, configApi, api } from "./endpoints";
import { CreateUserArgs, ListArgs, SearchTextArgs, Setting } from "MyAccountPlus-UIComponents";

export const getUsersListService = async (args: ListArgs) => {
    const res = await axios.get(host + baseUrl + tenant + adminApi.user + `?page=${args.page}&&size=${args.size}${args.sort ? "&&sort=" + args.sort + "," + args.order : ""}&&roles=${args.roles}${args.search?.length ? "&&search=" + encodeURIComponent(args.search) : ""}`, {
        headers: authHeader()
    });
    return res;
};

export const confirmUnconfirmUserService = async (userId: string) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.confirmUser + encodeURIComponent(userId), {}, {
        headers: authHeader()
    });
    return res;
};

export const addWorkflowAdvanceService = async (arg: WorkflowAdvanceArgs) => {
    const res = await axios.post(host + baseUrl + tenant + configApi.workflow + adminApi.workflowAdvance,
        arg, {
        headers: authHeader()
    });
    return res;
};

export const updateSettingService = async (data: Setting) => {
    const res = await axios.post(host + baseUrl + tenant + api.settings,
        data,
        {
            headers: authHeader(),
        });
    return res;
};

export const updateLogoService = async (data: Object) => {
    const res = await axios.post(host + baseUrl + tenant + api.assets + api.logos,
        data,
        {
            headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
        });
    return res;
};

export const updateImageService = async (data: Object) => {
    const res = await axios.post(host + baseUrl + tenant + api.assets + api.images,
        data,
        {
            headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' },
        });
    return res;
};

export const deleteLogoImageService = async (name: string) => {
    const res = await axios.delete(host + baseUrl + tenant + api.assets + "/" + name,
        {
            headers: authHeader(),
        });
    return res;
};

export const createUserService = async (data: CreateUserArgs) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.user,
        data,
        {
            headers: authHeader(),
        });
    return res;
};

export const updateUserService = async (data: CreateUserArgs) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.user + "/" + encodeURIComponent(data.userId || ""),
        data,
        {
            headers: authHeader(),
        });
    return res;
};

export const deleteUserService = async (name: string) => {
    const res = await axios.delete(host + baseUrl + tenant + adminApi.user + "/" + encodeURIComponent(name),
        {
            headers: authHeader(),
        });
    return res;
};

export const searchAccountService = async (data: Object, args: SearchTextArgs) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.accounts + adminApi.find + `?page=${args.page}&&size=${args.size}${args.sort ? "&&sort=" + args.sort + "," + args.order : ""}`,
        data, {
        headers: authHeader()
    });
    return res;
};

export const searchUserAccountService = async (args: SearchTextArgs) => {
    const res = await axios.get(host + baseUrl + tenant + adminApi.accounts + adminApi.find + `?searchText=${args.find_by ? encodeURIComponent(args.find_by) : ""}&&page=${args.page}&&size=${args.size}${args.sort ? "&&sort=" + args.sort + "," + args.order : ""}`,
        {
            headers: authHeader()
        });
    return res;
};

export const getAccountDetailService = async (accountId: string) => {
    const res = await axios.get(host + baseUrl + tenant + adminApi.accounts + "/" + accountId, {
        headers: authHeader(),
    });
    return res;
};

export const updateAccountStatusService = async (data: Object, accountId: string) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.accounts + '/' + accountId,
        data, {
        headers: authHeader()
    });
    return res;
};

export const updateAccountEamilService = async (data: Object, accountId: string) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.accounts + '/' + accountId,
        data, {
        headers: authHeader()
    });
    return res;
};

export const getAccountInquiriesService = async (args: ListArgs) => {
    const res = await axios.get(host + baseUrl + tenant + configApi.workflow + adminApi.inquiry + `?page=${args.page}&&size=${args.size}${args.sort ? "&&sort=" + args.sort + "," + args.order : ""}${args.search?.length ? "&&status=" + args.search : ""}`, {
        headers: authHeader()
    });
    return res;
};

export const getAccountApplicationService = async (args: ListArgs) => {
    const res = await axios.get(host + baseUrl + tenant + configApi.workflow + adminApi.accountApplication + `?page=${args.page}&&size=${args.size}${args.sort ? "&&sort=" + args.sort + "," + args.order : ""}${args.search?.length ? "&&status=" + args.search : ""}`, {
        headers: authHeader()
    });
    return res;
};

export const getAccountFuelOrderService = async (args: ListArgs) => {
    const res = await axios.get(host + baseUrl + tenant + configApi.workflow + adminApi.fuelOrder + `?page=${args.page}&&size=${args.size}${args.sort ? "&&sort=" + args.sort + "," + args.order : ""}${args.search?.length ? "&&status=" + args.search : ""}`, {
        headers: authHeader()
    });
    return res;
};

export const getNotificationConfigService = async () => {
    const res = await axios.get(host + baseUrl + tenant + adminApi.notificationsConfig, {
        headers: authHeader()
    });
    return res;
};

export const getNotificationConfigRoleService = async (role: string) => {
    const res = await axios.get(host + baseUrl + tenant + adminApi.notificationsConfig + adminApi.role + "/" + role, {
        headers: authHeader()
    });
    return res;
};

export const updateNotificationConfigService = async (data: NotificationConfigUpdate[]) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.notificationsConfig, data,
        {
            headers: authHeader()
        });
    return res;
};

export const registerUserService = async (data: SelfRegisterArgs) => {
    const res = await axios.post(host + baseUrl + tenant + adminApi.registerUser, data, {
        headers: authHeader()
    });
    return res;
};